<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <form v-on:submit.prevent="submit">
          <buttons top />
        </form>
      </div>
      <div class="col-md-6">
        <h4 style="display: inline-block;">Languages</h4>
        <p>Please add the languages you operate in.</p>
        <hr />
        <div stlye="position: relative; ">
          <multiSelectModal
            v-if="languageModalVisable"
            property="provider_languages"
            propertyName="language"
            v-on:close="toggleLanguageModal()"
            :search="true"
            :alphabet="true"
          />
        </div>

        <div>
          <div
            v-for="(language, index) in getProperty(['provider_languages'])"
            class="badge prop-badge"
          >
            {{ getFirst10(language["language"].name) }}
            <button
              style="padding-left: 7px; border-style: hidden; margin-top: 0px; line-height: 0.4;"
              class="close-badge"
              type="button"
              v-on:click="deleteProperty(index, 'provider_languages')"
            >
              <span aria-hidden="true" style="font-size: 20px; color: #d82d14;"
                >&times;</span
              >
            </button>
          </div>
        </div>
        <button
          class="btn-default btn-create"
          style="margin-left: 0px; margin-top: 10px;"
          v-on:click="toggleLanguageModal()"
        >
          Add language
        </button>
      </div>

      <div class="col-md-6">
        <h4 style="display: inline-block;">Currency</h4>
        <p>Please add the currencies you disburse funds in.</p>
        <hr />
        <div stlye="position: relative; ">
          <multiSelectModal
            v-if="currencyModalVisable"
            property="provider_currencies"
            propertyName="currency"
            v-on:close="toggleCurrencyModal()"
            :search="true"
            :alphabet="true"
          />
        </div>

        <div>
          <div
            v-for="(currency, index) in getProperty(['provider_currencies'])"
            class="badge prop-badge"
          >
            {{ getFirst10(currency["currency"].name) }}
            <button
              style="padding-left: 7px; border-style: hidden; margin-top: 0px; line-height: 0.4;"
              class="close-badge"
              type="button"
              v-on:click="deleteProperty(index, 'provider_currencies')"
            >
              <span aria-hidden="true" style="font-size: 20px; color: #d82d14;"
                >&times;</span
              >
            </button>
          </div>
        </div>
        <button
          class="btn-default btn-create"
          style="margin-left: 0px; margin-top: 10px;"
          v-on:click="toggleCurrencyModal()"
        >
          Add currency
        </button>
      </div>
    </div>

    <form v-on:submit.prevent="submit">
      <buttons />
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import multiSelectModal from "../elements/multiSelectModal.vue";
import buttons from "../elements/buttons.vue";
import utils from "./utils.js";

export default {
  name: "locale-page",
  components: {
    multiSelectModal: multiSelectModal,
    buttons: buttons
  },
  data: function() {
    return {
      languageModalVisable: false,
      currencyModalVisable: false
    };
  },
  computed: {
    ...mapGetters({
      getProperty: "getEditedProviderValueByKeyChain",
      providerPropertyToProperty: "providerPropertyToProperty",
      getNewProviderProperty: "getNewProviderProperty"
    })
  },
  methods: {
    deleteProperty: function(index, providerProperty) {
      this.$store.commit("deleteEditedProviderPropertyByKeyChain", [
        providerProperty,
        index
      ]);
    },
    toggleLanguageModal(index, provider) {
      this.languageModalVisable = !this.languageModalVisable;
    },
    toggleCurrencyModal(index, provider) {
      this.currencyModalVisable = !this.currencyModalVisable;
    },
    submit: function() {
      utils.post(this);
    },
    getFirst10: function(str) {
      return str.substring(0, 10) + "...";
    }
  },
  beforeRouteLeave: function(to, from, next) {
    var self = this;
    utils.beforeRouteLeave(self, to, from, next);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/localePage.vue